
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/layer",
      function () {
        return require("private-next-pages/docs/layer/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/layer"])
      });
    }
  